:host {
    @include grid;

    .main-content-container {
        display: grid;
        grid-auto-columns: 1fr;
        grid-auto-flow: column;
        column-gap: var(--column-gap);
        padding: 40px 0;
    }

    p {
        @include typo-ws-paragraph;

        margin: 0;
    }

    .dropdown-area,
    .input-area {
        display: flex;
        flex-direction: column;

        sew-combobox,
        sew-input {
            margin-top: auto;
        }

        p:has(+ sew-combobox),
        p:has(+ sew-input) {
            margin-bottom: 20px;
        }
    }

    sew-ws-button {
        align-self: flex-end;
        justify-self: start;
    }

    .links-headline {
        @include typo-ws-paragraph-bold;
    }

    .links-text {
        margin: 4px 0 0;
    }

    ::slotted(sew-ws-linklist) {
        margin-top: 12px;
    }
}

:host(.inside-flyout) {
    display: block;

    .dropdown-intro {
        @include typo-ws-h3;

        margin-bottom: 24px;
    }

    .main-content-container {
        grid-template-columns: 1fr;
        grid-auto-flow: row;
        row-gap: 40px;
        padding: 0;
    }

    sew-ws-button {
        width: 100%;
    }

    .dropdown-area {
        sew-combobox {
            margin-top: 20px;
        }
    }
}

@include mq-1 {
    :host {
        .main-content-container {
            grid-template-columns: 1fr;
            grid-auto-flow: row;
            row-gap: 40px;
            padding: 24px 0 40px;
        }

        .input-area {
            .product-input-title {
                margin-bottom: 20px;
            }
        }

        .dropdown-area {
            sew-combobox {
                margin-top: 20px;
            }
        }
    }
}
